<div [ngClass]="type" class="skeleton"></div>

